/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_HintInputs */

const cs_social_export_hint = /** @type {(inputs: Social_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerujte popisky a obrázky a publikujte na propojenou Facebook stránku a Instagram Business účet.`)
};

const en_social_export_hint = /** @type {(inputs: Social_Export_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate captions and images, then publish to your connected Facebook Page and Instagram Business account.`)
};

/**
* | output |
* | --- |
* | "Generate captions and images, then publish to your connected Facebook Page and Instagram Business account." |
*
* @param {Social_Export_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_hint = /** @type {((inputs?: Social_Export_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_hint(inputs)
	return cs_social_export_hint(inputs)
});